// extracted by mini-css-extract-plugin
module.exports = {"pageBody":"App_pageBody__1x1a1"};